
import React, { Component } from 'react'
import configureStore from './configureStore'
import AsyncAppHOC from './indexWrap'
const store = configureStore()

import { Provider } from 'react-redux'
const  AsyncAppHOCFN= WrappedComponent=>class extends Component{
    constructor(props) {
        super(props)
        this.state={
            locale:props.locale
        }
    }

    componentWillReceiveProps(nextProps){
        let locale=nextProps&&nextProps.locale
        if(this.props.locale==locale){
            return
        }
        this.setState({
            locale
        })
    }
    render() {
        return (
            <Provider store={store}>
                <AsyncAppHOC  render={({getDate,...other}) => (
                    <WrappedComponent getDate={getDate} locale={this.state.locale||'zh-CN'}  {...other} {...this.props}  />
                )}>
                </AsyncAppHOC>

            </Provider>)
    }
}
export default AsyncAppHOCFN